module.exports = __webpack_public_path__ + "static/assets/d80fa383213ce8841d2b31261f646b7e.gif";